<!--
单页面示例：字段较多、两列布局；
-->
<template>
  <div>
  </div>
<!-- 
   <iframe  width="100%" style="border: 0px;" height="100%" :src="'//'+util.apiBasePath+'/jpcp/project/add'">
  </iframe>
    <div class="rp-wrapper">
      <div class="rp-body">
        <div class="rp-form">
          
            
          <el-form ref="dataform"  :rules="rules"   :model="formData" label-width="140px"  :size="formSize">
             <div style="clear: both;"></div>
            <el-form-item size="large" style="text-align: center;">
                <el-button size="small" type="primary"  @click="add()" class="btn btn-solid"  >确定</el-button> 
                <el-button  size="small"  type="primary"  @click="goback()" class="btn btn-solid"  >返回</el-button> 
            </el-form-item>
          </el-form>
      
        </div>
      </div>
    </div>
    <scroll-right-frame >
  </scroll-right-frame>
-->
 
</template>
<script>
  import ScrollRightFrame from '../../../../components/scroll-right-frame'
  import util from '../../../../libs/util'
  export default {
    name: 'file-download',
    components: {ScrollRightFrame},
    data() {
      return {
        util:util
      }
    },
    watch: {
      '$route':function(to, from) {
                  
        }
    },
    mounted(){   
      const _than  = this;
      var fileId =this.$route.query.fileId;
       util.routerBack(_than,"/");
       var url ="/jpcp/uploader/file/"+fileId;
      window.open(url);
      // window.open("/jpcp/uploader/file/"+fileId);
    },
    methods: {

    },
    destroyed(){
       window.pushRoute =null;
    }
  }
</script>
<style lang="scss">
  
</style>


// WEBPACK FOOTER //
// src/custom/components/jpcp/project/file-download.vue